export const AUTOMATION_DISPATCH_JOB = 'automation:dispatch';
export const AUTOMATION_EXECUTE_JOB = 'automation:execute';
export const AUTOMATION_CRON_TICK_JOB = 'automation:cron-tick';
export const AUTOMATION_ENQUEUE_WHITELIST = ['kpi:snapshot-daily'];
export const AUTOMATION_STEP_TYPES = [
    'lead_add_tag',
    'lead_set_status',
    'lead_append_note',
    'emit_webhook',
    'enqueue_job',
    'run_agent',
    'draft_reply',
    'generate_analytics_report',
];
export const AUTOMATION_TRIGGER_TYPES = ['event', 'cron', 'manual'];
export const AUTOMATION_RUN_STATUSES = [
    'pending',
    'running',
    'succeeded',
    'failed',
    'skipped',
    'cancelled',
];
//# sourceMappingURL=automationJobs.js.map